import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'servicedesk-settings-customer-portal-v2.page-header',
		defaultMessage: 'Portal',
		description: 'The title of the the service project settings page for Customer portal settings',
	},
	classicPageHeader: {
		id: 'servicedesk-settings-customer-portal-v2.classic-page-header',
		defaultMessage: 'Portal settings',
		description: 'The title of the the service project settings page for portal settings',
	},
	portalDetails: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details',
		defaultMessage: 'Portal details',
		description: 'Header on the service project settings page for Customer portal settings',
	},
	invalidUrlTitle: {
		id: 'servicedesk-settings-customer-portal-v2.invalid-url-title',
		defaultMessage: 'We couldn’t load your portal URL',
		description: 'Title of error flag shown when getting invalid url.',
	},
	invalidUrlDescription: {
		id: 'servicedesk-settings-customer-portal-v2.invalid-url-description',
		defaultMessage:
			'We’ve experienced a technical issue while trying to load your portal URL. You’ll need to contact support to resolve this problem.',
		description: 'Description of error flag shown when getting invalid url.',
	},
	invalidUrlAction: {
		id: 'servicedesk-settings-customer-portal-v2.invalid-url-action',
		defaultMessage: 'Contact support',
		description: 'Action of error flag shown when getting invalid url.',
	},
});
